import { Instagram, Linkedin, Facebook, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FOOTER } from '../../constants/testIds';
import { PROJECT } from '../../data/content';

const COLS = [
  {
    title: 'Aravi',
    links: [
      { label: 'Philosophy', to: '/philosophy' },
      { label: 'Leadership', to: '/philosophy#team' },
      { label: 'Sustainability', to: '/sustainability' },
      { label: 'The Setting', to: '/landscapes' },
    ],
  },
  {
    title: 'Homes',
    links: [
      { label: 'The 605', to: '/residences/the-605' },
      { label: 'The 1210', to: '/residences/the-1210' },
      { label: 'All Homes', to: '/residences' },
      { label: 'Amenities', to: '/sustainability' },
    ],
  },
  {
    title: 'Visit',
    links: [
      { label: 'Schedule a Visit', to: '/contact' },
      { label: 'Site Location', to: '/contact' },
      { label: 'Connectivity', to: '/landscapes' },
      { label: 'Enquire', to: '/contact' },
    ],
  },
];

export const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-[#18342A] text-[#F5F1E8] grain-overlay overflow-hidden"
    >
      <div className="px-6 md:px-10 lg:px-16 max-w-[1500px] mx-auto pt-24 lg:pt-28 pb-10 relative z-10">
        <div className="grid grid-cols-12 gap-10 lg:gap-16">
          {/* Brand */}
          <div className="col-span-12 lg:col-span-5">
            <Link to="/" className="flex flex-col leading-none w-fit">
              <span className="font-serif tracking-[0.25em] text-3xl text-[#F5F1E8]" style={{ fontWeight: 500 }}>
                ARAVI
              </span>
              <span className="text-[10px] tracking-[0.45em] mt-2 text-[#C9A458]">
                ECO HOMES
              </span>
            </Link>
            <p className="mt-8 max-w-sm text-[#F5F1E8]/70 text-sm leading-relaxed font-light">
              A nature-crafted community on the southern Hyderabad corridor —
              within HMDA Limits, ringed by the 1,100-acre Osmania Geological
              Observatory belt (forest). 25 acres · 110 villas.
            </p>

            <div className="mt-8 space-y-3 text-[#F5F1E8]/70 text-sm font-light">
              <a href={`tel:${PROJECT.phoneRaw}`} className="flex items-center gap-3 hover:text-[#C9A458] transition-colors">
                <Phone size={14} strokeWidth={1.5} />
                {PROJECT.phone}
              </a>
              <a href={`tel:${PROJECT.phoneAltRaw}`} className="flex items-center gap-3 hover:text-[#C9A458] transition-colors">
                <Phone size={14} strokeWidth={1.5} />
                {PROJECT.phoneAlt}
              </a>
              <a href={`mailto:${PROJECT.email}`} className="flex items-center gap-3 hover:text-[#C9A458] transition-colors">
                <Mail size={14} strokeWidth={1.5} />
                {PROJECT.email}
              </a>
            </div>

            <div className="mt-8 flex items-center gap-3">
              {[Instagram, Linkedin, Facebook].map((Icon, i) => (
                <a
                  key={i}
                  href="https://example.com"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Social link"
                  className="w-10 h-10 grid place-items-center border border-[#F5F1E8]/20 text-[#F5F1E8]/80 hover:border-[#C9A458] hover:text-[#C9A458] transition-colors"
                >
                  <Icon size={15} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {COLS.map((col) => (
            <div key={col.title} className="col-span-6 md:col-span-4 lg:col-span-2">
              <h4 className="text-[10px] tracking-[0.4em] uppercase text-[#C9A458] mb-6">
                {col.title}
              </h4>
              <ul className="space-y-4">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-[#F5F1E8]/80 text-sm hover:text-[#C9A458] transition-colors font-light"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="col-span-12 lg:col-span-1 hidden lg:block" />
        </div>

        {/* Watermark */}
        <div className="mt-20 lg:mt-24 overflow-hidden">
          <div
            className="font-serif text-[#F5F1E8]/[0.05] tracking-tight leading-none select-none"
            style={{ fontSize: 'clamp(80px, 18vw, 280px)', fontWeight: 300 }}
          >
            ARAVI
          </div>
        </div>

        <div className="border-t border-[#F5F1E8]/10 pt-8 mt-2 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#F5F1E8]/50">
            © {new Date().getFullYear()} Aravi Eco Homes Private Limited · HMDA Limits · CREDAI · IGBC
          </p>
          <div className="flex items-center gap-6 text-[10px] tracking-[0.3em] uppercase text-[#F5F1E8]/50">
            <a href={PROJECT.mapsUrl} target="_blank" rel="noreferrer" className="hover:text-[#C9A458]">Site Location</a>
            <a href="https://example.com" className="hover:text-[#C9A458]">Privacy</a>
            <a href="https://example.com" className="hover:text-[#C9A458]">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
